
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between">
      <div class=" p-2">
        <span class="box-title mr-2">Oficial: </span>
        <span class="box-subtitle">{{informacion?.oficial}}</span>
      </div>

      <div class=" p-2">
        <span class="box-title mr-2">Fecha de Apertura: </span>
        <span class="box-subtitle">{{informacion?.fechaApertura}}</span>
      </div>
    </div>

  
    <ul class="list-group list-group-flush">
      <li class="list-group-item d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          Disponible
          <span class="material-icons ml-2">
            chevron_right
          </span>
        </div>
        <div>{{informacion?.disponibleTransaccion| currency}}</div>
      </li>
      <li class="list-group-item d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          Bloqueo
          <span class="material-icons ml-2">
            chevron_right
          </span>
        </div>
        <div>{{informacion?.componentesCuenta?.[3]?.saldo || 0 | currency}}</div>
      </li>
      <li class="list-group-item d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          Cheques
          <span class="material-icons ml-2">
            chevron_right
          </span>
        </div>
        <div>{{informacion?.componentesCuenta?.[1]?.saldo || 0 | currency}}</div>
      </li>
    </ul>
  </div>
  


